//deps
import React, { memo, ReactElement, useMemo } from "react";
import cx from "classnames";

//widgets
import PaymentMethodIcon from "@payment-ui/widgets/payment-method-icon/PaymentMethodIcon";

//styles
import styles from "./styles.scss";

//data-test-ids
import { ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";

//constants
import { TEXTS } from "@payment-ui/constants/index";

//internal-deps
import { getCloudinaryUrl } from "@swiggy-private/core-ui";
import { LIMITLESS_BALANCE_TEXT } from "./constant";

interface HeaderProps {
    balance: string;
    showBalance: boolean;
    iconUrl: string;
    containerClassName?: string;
    isLimitless?: boolean;
}

function Header({ balance, iconUrl, containerClassName, showBalance, isLimitless }: HeaderProps): ReactElement {
    const containerClass = cx(styles.headerContainer, containerClassName);
    const cloudinaryIconUrl = useMemo(() => getCloudinaryUrl(iconUrl), [iconUrl]);

    const balanceClass = cx(styles.headerBalance, {
        [styles.headerLimitlessBalance]: isLimitless,
    });

    const balanceText = isLimitless ? LIMITLESS_BALANCE_TEXT : balance;

    return (
        <div className={containerClass}>
            {showBalance && (
                <div>
                    <div
                        className={styles.headerTitle}
                        data-testid={ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS.HEADER_TITLE}
                    >
                        {TEXTS.CURRENT_BALANCE}
                    </div>
                    <div className={balanceClass} data-testid={ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS.BALANCE}>
                        {balanceText}
                    </div>
                </div>
            )}
            <PaymentMethodIcon
                data-testid={ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS.WALLET_ICON}
                parentClassName={styles.headerIconContainer}
                src={cloudinaryIconUrl}
            />
        </div>
    );
}

export default memo(Header);
